import ScrollToElement from 'contest/ui/scroll-to-element';
import EntryThumbnailUI from 'contest/ui/entry-thumbnail';
import HeroCarouselUI from 'contest/ui/hero-carousel';
import ScrollableUI from 'marketing/ui/scrollable';
import BreakpointBroadcasterUI from 'app/ui/breakpoint-broadcaster';
import { currentBreakpoint } from 'app/utils/breakpoints';

document.addEventListener('DOMContentLoaded', () => {
    BreakpointBroadcasterUI.attachTo(document);
    const scrollToElements = document.querySelectorAll('[data-scrollto]');
    Array.from(scrollToElements).forEach(element => new ScrollToElement(element).handleClick());

    HeroCarouselUI.attachTo('[data-carousel]');
    EntryThumbnailUI.attachTo('[data-entry]');
    ScrollableUI.attachTo('[data-scrollable]', {
        startingBreakpoint: currentBreakpoint(),
    });

    $('[data-async-src]').each(function(e, i) {
        $(this).attr('src', $(this).data('async-src'));
    });
});



// WEBPACK FOOTER //
// ./src/web/js/contest/marketing-summary.js